import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ProductViewGraphicsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-view-graphics',
    templateUrl: 'product-view-graphics.html',
})
export class ProductViewGraphicsPage {
    @Input() product: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams
    ) {
    }

}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view-graphics/product-view-graphics.ts